import React, { useEffect, useRef, useMemo, useState } from "react";
import { Context,Hooks,Util,Request,isRtlLocale } from "@xt/xtbase";
const {XtContext,XtAuth} = Context;
const {useTranslation} = Hooks;
const {regexp, getUrl} = Util;
import styles from "./index.module.less";
import { useStore } from '@/models';
import { observer } from 'mobx-react-lite';
import { resolveCfdSymbol } from "@/@xt/Nav/src/utils/getCfdSymbol";
import banner from "assets/images/homeNew/banner.png";
import banner_dark from "assets/images/homeNew/banner-dark.png";
import { message } from "antd";

const HomeBanner = (props) => {
  const t = useTranslation();
  const { app, fund } = useStore();
  const [appState] = React.useContext(XtContext);
  const {lang, theme, loginStatus} = appState;
  const rtl = isRtlLocale(lang);
  const isLogin = loginStatus == 1;
  const [cfdMarket, setCfdMarket] = useState("btc_usdt_cfd");
  const recommendedCurrencyKey = useMemo(() => {
    return (fund?.recommendedCurrencyList || [])
      .map((item) => `${item?.currency || ""}:${(item?.plates || []).join(",")}`)
      .join("|");
  }, [fund?.recommendedCurrencyList, fund?.recommendedCurrencyListMd5]);
  const router = {
    sign: getUrl("/accounts/register"),
    trade: getUrl(`/futures/contract/${cfdMarket}`),
    login: getUrl("/accounts/login"),
  }
  const inputAddressRef = useRef();
  const onSearch = (val)=>{
    var val = inputAddressRef.current.value;
    console.log(val);
    const isValid = regexp("email", val);
    if(!isValid)
    {
      message.error(t("home.plsInputEmail"));
      return;
    }
    location.href = getUrl("/accounts/register?email="+val);
  }
  const heroImg = banner_dark;

  useEffect(() => {
    let cancelled = false;
    resolveCfdSymbol({
      fiatCurrencyIds: appState?.userInfo?.fiatCurrencyIds,
      loginStatus,
    }).then((symbol) => {
      if (!cancelled) {
        setCfdMarket(symbol);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [appState?.userInfo?.fiatCurrencyIds, loginStatus, recommendedCurrencyKey]);

  if (props.variant === "landing") {
    return (
      <section className={`${styles.landingHero} ${rtl ? styles.landingHeroRtl : ""}`}>
        <div className={styles.landingHeroInner}>
          <div className={styles.landingHeroCopy}>
            <h1 className={styles.landingHeroTitle}>
              <span className={styles.landingHeroLine1}>{t("home.worldsFirst").toUpperCase()}</span>
              <span className={styles.landingHeroLine2}>{t("home.socialInfusedExchange").toUpperCase()}</span>
            </h1>
            <p className={styles.landingHeroSub}>{t("home.BestSelection")}</p>
            {/* <XtAuth renderNotLogin={
              () => {
                return <div className={`${styles.homeLogin} ${styles.landingHomeLogin}`}>
                  <input ref={inputAddressRef} placeholder={t('home.quickRegToolAddress')} />
                  <p onClick={onSearch}>{t('home.signUp')}</p>
                </div>
              }
            }></XtAuth>
            {isLogin && <div className={styles['banner-action-box']}>
              <a href={router['trade']} className={styles['banner-action']}>{t("home.promptly")}</a>
            </div>} */}
          </div>
          <div
            className={styles.landingHeroVisual}
            style={{
              backgroundImage: `linear-gradient(87.43deg, rgb(24, 26, 32) 3.15%, rgba(24, 26, 32, 0) 26.88%), url(${heroImg})`,
            }}
            aria-hidden
          />
        </div>
      </section>
    );
  }
  return (
    <div className={styles["banner-container"]} style={app.isH5 ? {} : {backgroundImage:`url(${theme=="light"?banner:banner_dark})`}}>
      <div className={styles["box"]}>
        <div className={styles["banner-container-box"]}>
          <div className={styles["banner-title"]} data-wow-delay="0.2s">
            <h1 className={`${styles["big-tit"]} ${styles["n-font-fm"]}`}>
              <span className={styles["worlds-first"]}>{t("home.worldsFirst").toUpperCase()}</span> {t("home.socialInfusedExchange").toUpperCase()}
            </h1>
            <p className={`${styles["little-tit"]} ${styles["n-font-fm"]}`}>{ t("home.BestSelection") }</p>
          </div>
          <XtAuth renderNotLogin={
            () => {
              return <div className={styles.homeLogin}>
                <input ref={inputAddressRef} placeholder={t('home.quickRegToolAddress')} />
                <p onClick={onSearch}>{t('home.signUp')}</p>
              </div>
            }
          }></XtAuth>
          {isLogin && <div className={styles['banner-action-box']}>
            <a href={router['trade']} className={styles['banner-action']}>{t("home.promptly")}</a>
          </div>}
        </div>
      </div>
  </div>
  );
}
export default observer(HomeBanner);
